var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { Router, ActivatedRoute } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { KtsInformationClaimStatusSelectService, InformationTemplate } from './information-claim-status-select.service';
var KtsInformationClaimStatusSelectComponent = /** @class */ (function (_super) {
    __extends(KtsInformationClaimStatusSelectComponent, _super);
    function KtsInformationClaimStatusSelectComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.rec = new InformationTemplate();
        _this.information_type = [];
        _this.status = [];
        _this.readonly = false;
        return _this;
    }
    KtsInformationClaimStatusSelectComponent.prototype.ngOninit = function () {
        _super.prototype.ngOnInit.call(this);
        this.mode = jsonpath.value(this.component, '$.params.mode)');
        this.getType();
        this.setCompRec();
    };
    KtsInformationClaimStatusSelectComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsInformationClaimStatusSelectComponent.prototype.onSubscribe = function (data) {
        this.setCompRec();
    };
    KtsInformationClaimStatusSelectComponent.prototype.getType = function () {
        var _this = this;
        this.service.getType('INFORMATION_TYPE').subscribe(function (rec) { return _this.information_type = rec; });
        this.service.getType('INFORMATION_STATUS').subscribe(function (rec) { return _this.status = rec; });
    };
    KtsInformationClaimStatusSelectComponent.prototype.onEventSubscribe = function (e) {
        this.getType();
    };
    KtsInformationClaimStatusSelectComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    KtsInformationClaimStatusSelectComponent.prototype.onChange = function (e) {
        this.rec[e.key] = e.val;
        this.setCompRec();
    };
    KtsInformationClaimStatusSelectComponent.prototype.setCompRec = function () {
        if (this.rec['information_type'] !== 'complaint') {
            delete this.rec['status'];
        }
        this.action.setCompRec(this.componentName, this.rec);
    };
    KtsInformationClaimStatusSelectComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-information-claim-status-select',
                    template: "<form id=\"{{ componentName }}\">\n  <div *ngIf=\"information_type.length > 0\" class=\"row\">\n    <div class=\"col-sm-12\">\n      <column [key]=\"'form'\" [col]=\"{\n        label: (msg | async)['au.COMPONENT.KtsInformationClaimStatusSelectComponent.label.type'],\n        key: 'information_type',\n        controlType: 'select',\n        readonly: (mode !== 'entry'),\n        required: true,\n        params: {options: information_type}\n      }\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n    </div>\n  </div>\n  <ng-template [ngIf]=\"rec.information_type === 'complaint'\">\n    <div class=\"row -mt-1\">\n      <div class=\"col-sm-12\">\n        <column [key]=\"'form'\" [col]=\"{\n          label: (msg | async)['au.COMPONENT.KtsInformationClaimStatusSelectComponent.label.status'],\n          key: 'status',\n          controlType: 'select',\n          readonly: (mode === 'confirm'),\n          required: true,\n          params: {options: status}\n        }\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n      </div>\n    </div>\n  </ng-template>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsInformationClaimStatusSelectComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsInformationClaimStatusSelectService }
    ]; };
    return KtsInformationClaimStatusSelectComponent;
}(ContentBaseComponent));
export { KtsInformationClaimStatusSelectComponent };
//# sourceMappingURL=information-claim-status-select.component.js.map